import { render, staticRenderFns } from "./ProductPreviewPrizeView.vue?vue&type=template&id=462f44af&scoped=true"
import script from "./ProductPreviewPrizeView.vue?vue&type=script&lang=js"
export * from "./ProductPreviewPrizeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462f44af",
  null
  
)

export default component.exports